import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import getQuestionDescription from '../utils/getQuestionDescription';
import getQuestionStyleName from '../utils/getQuestionStyleName';
import getQuestionText from '../utils/getQuestionText';
import { enhance } from './enhance';

const Question = ({ text, settings, onLink, markOptional, viewPosition }) => {
  const description = getQuestionDescription({
    ...settings,
    text,
    onLink,
  });

  const styleName = getQuestionStyleName(get(settings, 'name'));
  const isRequired = get(settings, 'isRequired', true);
  const questionText = getQuestionText({ text, ...settings });
  const questionName = get(settings, 'name');
  return (
    <div styleName={`text ${styleName}`}>
      {questionText && (
        <p>
          {`${
            viewPosition
              ? `${viewPosition} ${questionText} `
              : `${questionText} `
          }`}
          <span styleName="optional">
            {isRequired || questionName === 'comment' ? '' : markOptional()}
          </span>
        </p>
      )}

      {description && <div styleName="description">{description}</div>}
    </div>
  );
};

Question.propTypes = {
  text: PropTypes.string,
  onLink: PropTypes.func,
  markOptional: PropTypes.func,
  viewPosition: PropTypes.string,
  settings: PropTypes.shape({
    meta: PropTypes.object,
  }),
};

export default enhance(Question);



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Question/index.jsx